import React from 'react';
import Constant from 'utils/Constant';

const Container = ({
  className,
  ...props
}: React.PropsWithRef<React.HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div
      className={
        Constant.firebaseConfig.projectId.includes('production')
          ? 'bg-background'
          : 'bg-brand-stone'
      }
    >
      <div
        {...props}
        className={`container justify-center flex flex-col py-8 items-center min-h-screen mx-auto px-4 ${className}`}
      />
    </div>
  );
};

export default Container;
